import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { Skill, SkillCategory } from '@/types'
import { createSkill } from '@/lib/api'
import { Card } from '@/components/ui/Card'
import { TextField, TextAreaField, SelectField, SaveBar } from '@/components/ui/FormFields'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

const empty: Skill = {
  id: '',
  name: '',
  skill_category: 'operacional',
  version: '1.0',
  description: '',
  docs: '',
  updated_at: new Date().toISOString(),
}

export function SkillNew() {
  const navigate = useNavigate()
  const [skill, setSkill] = useState<Skill>(empty)
  const [saving, setSaving] = useState(false)
  const [result, setResult] = useState<string | null>(null)

  function update<K extends keyof Skill>(key: K, value: Skill[K]) {
    setSkill((prev) => ({ ...prev, [key]: value }))
  }

  async function handleSave() {
    if (!skill.id || !skill.name) {
      setResult('ID y Nombre son obligatorios')
      return
    }
    setSaving(true)
    setResult(null)
    try {
      await createSkill(skill)
      navigate(`/skills/${skill.id}`)
    } catch (e) {
      setResult(e instanceof Error ? e.message : 'Error al crear')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div>
      <PendingBackendNotice endpoint="POST /skills" />
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 16 }}>Nuevo Skill</h1>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Card>
          <TextField label="ID (ej. manejo-reclamos)" value={skill.id} onChange={(v) => update('id', v)} mono />
          <TextField label="Nombre" value={skill.name} onChange={(v) => update('name', v)} />
          <TextField label="Versión" value={skill.version} onChange={(v) => update('version', v)} mono />
          <SelectField
            label="Categoría"
            value={skill.skill_category ?? 'operacional'}
            onChange={(v) => update('skill_category', v as SkillCategory)}
            options={['conversacional', 'operacional', 'analítico', 'marca']}
          />
        </Card>
        <Card>
          <TextAreaField label="Descripción" value={skill.description ?? ''} onChange={(v) => update('description', v)} rows={3} />
          <TextAreaField label="Docs (markdown)" value={skill.docs ?? ''} onChange={(v) => update('docs', v)} rows={10} />
        </Card>
      </div>

      <SaveBar onSave={handleSave} saving={saving} result={result} />
    </div>
  )
}
